import bootReactRailsUJS from "../utils/bootReactRailsUJS";

const componentRequireContext = require.context(
  "components",
  true,
  /frame-designer\/print\/Uploader\.(js|jsx|ts|tsx)$|frame-designer\/upload\/ImageBrowser\.(js|jsx|ts|tsx)$|frame-designer\/qr\/DigitalUploadPhoneModal\.(js|jsx|ts|tsx)$/,
);

bootReactRailsUJS(componentRequireContext);
